export const iconsData = [
  {
    file: "youtube.tsx",
    name: "YoutubeIcon",
  },
  {
    file: "xml-solid.tsx",
    name: "XMLIcon",
  },
  {
    file: "workplace.tsx",
    name: "WorkplaceIcon",
  },
  {
    file: "weighing-scale.tsx",
    name: "WeighingScale",
  },
  {
    file: "washing-machine.tsx",
    name: "WashingMachineIcon",
  },
  {
    file: "walkman.tsx",
    name: "WalkmanIcon",
  },
  {
    file: "walkman-with-exclamation.tsx",
    name: "WalkmanWithExclamationIcon",
  },
  {
    file: "visa.tsx",
    name: "VisaIcon",
  },
  {
    file: "video-solid.tsx",
    name: "VideoIcon",
  },
  {
    file: "vegetables.tsx",
    name: "VegetablesIcon",
  },
  {
    file: "users-outline.tsx",
    name: "UsersOutlineIcon",
  },
  {
    file: "users-color.tsx",
    name: "UsersColorIcon",
  },
  {
    file: "user-settings.tsx",
    name: "UserSettingsIcon",
  },
  {
    file: "user-plus.tsx",
    name: "UserPlusIcon",
  },
  {
    file: "user-lock.tsx",
    name: "UserLockIcon",
  },
  {
    file: "user-info.tsx",
    name: "UserInfoIcon",
  },
  {
    file: "user-family-color.tsx",
    name: "UserFamilyColorIcon",
  },
  {
    file: "user-color.tsx",
    name: "UserColorIcon",
  },
  {
    file: "user-cog.tsx",
    name: "UserCog",
  },
  {
    file: "user-avatar.tsx",
    name: "UserAvatarIcon",
  },
  {
    file: "twitter.tsx",
    name: "TwitterIcon",
  },
  {
    file: "turtle.tsx",
    name: "TurtleIcon",
  },
  {
    file: "truck.tsx",
    name: "TruckIcon",
  },
  {
    file: "truck-solid.tsx",
    name: "TruckSolidIcon",
  },
  {
    file: "trophy.tsx",
    name: "TrophyIcon",
  },
  {
    file: "trending.tsx",
    name: "TrendingIcon",
  },
  {
    file: "trending-up.tsx",
    name: "TrendingUpIcon",
  },
  {
    file: "trending-down.tsx",
    name: "TrendingDownIcon",
  },
  {
    file: "trash.tsx",
    name: "TrashIcon",
  },
  {
    file: "transactions.tsx",
    name: "TransactionIcon",
  },
  {
    file: "ticket.tsx",
    name: "TicketIcon",
  },
  {
    file: "thumbs-up.tsx",
    name: "ThumbsUpIcon",
  },
  {
    file: "tent.tsx",
    name: "TentIcon",
  },
  {
    file: "telegram.tsx",
    name: "TelegramIcon",
  },
  {
    file: "teams.tsx",
    name: "TeamsIcon",
  },
  {
    file: "tag.tsx",
    name: "TagIcon",
  },
  {
    file: "tag-3.tsx",
    name: "TagIcon3",
  },
  {
    file: "tag-2.tsx",
    name: "TagIcon2",
  },
  {
    file: "table-sticky-header.tsx",
    name: "TableStickyHeaderIcon",
  },
  {
    file: "table-search.tsx",
    name: "TableSearchIcon",
  },
  {
    file: "table-enhanced.tsx",
    name: "TableEnhancedIcon",
  },
  {
    file: "table-collapsible.tsx",
    name: "TableCollapsibleIcon",
  },
  {
    file: "table-basic.tsx",
    name: "TableBasicIcon",
  },
  {
    file: "swimming-pool.tsx",
    name: "SwimmingPoolIcon",
  },
  {
    file: "sweet.tsx",
    name: "SweetIcon",
  },
  {
    file: "suitcase.tsx",
    name: "SuitcaseIcon",
  },
  {
    file: "suit-case.tsx",
    name: "SuitCaseIcon",
  },
  {
    file: "stack.tsx",
    name: "StackIcon",
  },
  {
    file: "square-box.tsx",
    name: "SquareBoxIcon",
  },
  {
    file: "social-media-dash.tsx",
    name: "SocialMediaDashIcon",
  },
  {
    file: "smoke-alarm.tsx",
    name: "SmokeAlarmIcon",
  },
  {
    file: "slack.tsx",
    name: "SlackIcon",
  },
  {
    file: "skyscraper.tsx",
    name: "SkyscraperIcon",
  },
  {
    file: "shopping-cart.tsx",
    name: "ShoppingCartIcon",
  },
  {
    file: "shopping-cart-alt.tsx",
    name: "ShoppingCartAlt",
  },
  {
    file: "shopping-bag-solid.tsx",
    name: "ShoppingBagSolidIcon",
  },
  {
    file: "shopify.tsx",
    name: "ShopifyIcon",
  },
  {
    file: "shop.tsx",
    name: "ShopIcon",
  },
  {
    file: "shooting-star.tsx",
    name: "ShootingStarIcon",
  },
  {
    file: "shipping-box.tsx",
    name: "ShippingBox",
  },
  {
    file: "ship.tsx",
    name: "ShipIcon",
  },
  {
    file: "ship-with-container.tsx",
    name: "ShipWithContainer",
  },
  {
    file: "settings-warning.tsx",
    name: "SettingsWarningIcon",
  },
  {
    file: "schedule.tsx",
    name: "ScheduleIcon",
  },
  {
    file: "schedule-light.tsx",
    name: "ScheduleLightIcon",
  },
  {
    file: "sales.tsx",
    name: "SalesIcon",
  },
  {
    file: "room-single-color.tsx",
    name: "RoomSingleIconColor",
  },
  {
    file: "room-shared-color.tsx",
    name: "RoomSharedIconColor",
  },
  {
    file: "rocket-flaming.tsx",
    name: "RocketFlamingIcon",
  },
  {
    file: "ring-bell-solid.tsx",
    name: "RingBellSolidIcon",
  },
  {
    file: "revenue-up.tsx",
    name: "RevenueUpIcon",
  },
  {
    file: "refund.tsx",
    name: "RefundIcon",
  },
  {
    file: "real-estate.tsx",
    name: "RealEstateIcon",
  },
  {
    file: "project-write.tsx",
    name: "ProjectWriteIcon",
  },
  {
    file: "project-dash.tsx",
    name: "ProjectDashIcon",
  },
  {
    file: "pool-table.tsx",
    name: "PoolTableIcon",
  },
  {
    file: "point-of-sell.tsx",
    name: "PointOfSellIcon",
  },
  {
    file: "plane.tsx",
    name: "PlaneIcon",
  },
  {
    file: "pizza.tsx",
    name: "PizzaIcon",
  },
  {
    file: "pine-apple.tsx",
    name: "PineAppleIcon",
  },
  {
    file: "pie-chart-currency.tsx",
    name: "PieChartCurrencyIcon",
  },
  {
    file: "pencil.tsx",
    name: "PencilIcon",
  },
  {
    file: "pdf-solid.tsx",
    name: "PDFIcon",
  },
  {
    file: "pasta.tsx",
    name: "PastaIcon",
  },
  {
    file: "parcel-map.tsx",
    name: "ParcelMapIcon",
  },
  {
    file: "page-blank.tsx",
    name: "PageBlankIcon",
  },
  {
    file: "package-open.tsx",
    name: "PackageOpenIcon",
  },
  {
    file: "online-payment.tsx",
    name: "OnlinePaymentIcon",
  },
  {
    file: "notion.tsx",
    name: "NotionIcon",
  },
  {
    file: "notification-settings.tsx",
    name: "NotificationSettingsIcon",
  },
  {
    file: "nft.tsx",
    name: "NftIcon",
  },
  {
    file: "newsletter-announcement.tsx",
    name: "NewsletterAnnouncement",
  },
  {
    file: "music-solid.tsx",
    name: "MusicIcon",
  },
  {
    file: "multi-step-arrow.tsx",
    name: "MultiStepArrowIcon",
  },
  {
    file: "money-in-hand.tsx",
    name: "MoneyInHand",
  },
  {
    file: "mobile-home.tsx",
    name: "MobileHomeIcon",
  },
  {
    file: "meter.tsx",
    name: "MeterIcon",
  },
  {
    file: "medium.tsx",
    name: "MediumIcon",
  },
  {
    file: "mastercard.tsx",
    name: "MasterCardIcon",
  },
  {
    file: "map-marker-with-path.tsx",
    name: "MapMarkerWithPathIcon",
  },
  {
    file: "magnifying-with-cross.tsx",
    name: "MagnifyingWithCrossIcon",
  },
  {
    file: "magnifying-with-bar.tsx",
    name: "MagnifyingWithBarIcon",
  },
  {
    file: "magnifying-glass-color.tsx",
    name: "MagnifyingGlassIconColor",
  },
  {
    file: "lunch.tsx",
    name: "LunchIcon",
  },
  {
    file: "luggage.tsx",
    name: "LuggageIcon",
  },
  {
    file: "luggage-two.tsx",
    name: "LuggageTwoIcon",
  },
  {
    file: "lock-wild-card.tsx",
    name: "LockWildCardIcon",
  },
  {
    file: "lock-exclamation.tsx",
    name: "LockExclamationIcon",
  },
  {
    file: "linkedin.tsx",
    name: "LinkedinIcon",
  },
  {
    file: "linkedin-square.tsx",
    name: "LinkedInSquareIcon",
  },
  {
    file: "light-mode.tsx",
    name: "LightMode",
  },
  {
    file: "kitchen.tsx",
    name: "KitchenIcon",
  },
  {
    file: "invoice.tsx",
    name: "InvoiceIcon",
  },
  {
    file: "invoice-print.tsx",
    name: "InvoicePrint",
  },
  {
    file: "instagram.tsx",
    name: "InstagramIcon",
  },
  {
    file: "image-solid.tsx",
    name: "ImageIcon",
  },
  {
    file: "hubspot.tsx",
    name: "HubSpotIcon",
  },
  {
    file: "house.tsx",
    name: "HouseIcon",
  },
  {
    file: "house-boat.tsx",
    name: "HouseBoatIcon",
  },
  {
    file: "hour-glass.tsx",
    name: "HourGlassIcon",
  },
  {
    file: "hour-glass-round.tsx",
    name: "HourGlassRoundIcon",
  },
  {
    file: "hand-wave.tsx",
    name: "HandWaveIcon",
  },
  {
    file: "half-circle-right.tsx",
    name: "HalfCircleRightIcon",
  },
  {
    file: "half-circle-left.tsx",
    name: "HalfCircleLeftIcon",
  },
  {
    file: "gym.tsx",
    name: "GymIcon",
  },
  {
    file: "green-leaf.tsx",
    name: "GreenLeafIcon",
  },
  {
    file: "google.tsx",
    name: "GoogleIcon",
  },
  {
    file: "github.tsx",
    name: "GithubIcon",
  },
  {
    file: "french-fries.tsx",
    name: "FrenchFriesIcon",
  },
  {
    file: "folder-solid.tsx",
    name: "FolderIcon",
  },
  {
    file: "folder-lock.tsx",
    name: "FolderLockIcon",
  },
  {
    file: "flight-icon.tsx",
    name: "FlightIcon",
  },
  {
    file: "fire-extinguisher.tsx",
    name: "FireExtinguisherIcon",
  },
  {
    file: "financial-statistics.tsx",
    name: "FinancialStatisticsIcon",
  },
  {
    file: "files.tsx",
    name: "FilesIcon",
  },
  {
    file: "file-stack.tsx",
    name: "FileStackIcon",
  },
  {
    file: "file-settings.tsx",
    name: "FileSettingsIcon",
  },
  {
    file: "figma.tsx",
    name: "FigmaIcon",
  },
  {
    file: "farm-house.tsx",
    name: "FarmHouseIcon",
  },
  {
    file: "facebook.tsx",
    name: "FacebookIcon",
  },
  {
    file: "facebook-square.tsx",
    name: "FacebookSquareIcon",
  },
  {
    file: "eye.tsx",
    name: "EyeIcon",
  },
  {
    file: "express-delivery.tsx",
    name: "ExpressDeliveryIcon",
  },
  {
    file: "expenses.tsx",
    name: "ExpenseIcon",
  },
  {
    file: "exchange.tsx",
    name: "ExchangeIcon",
  },
  {
    file: "envato.tsx",
    name: "EnvatoIcon",
  },
  {
    file: "drive-solid.tsx",
    name: "DriveIcon",
  },
  {
    file: "dollar.tsx",
    name: "DollarIcon",
  },
  {
    file: "doc-solid.tsx",
    name: "DocIcon",
  },
  {
    file: "dinner.tsx",
    name: "DinnerIcon",
  },
  {
    file: "dining.tsx",
    name: "DiningIcon",
  },
  {
    file: "dices.tsx",
    name: "DicesIcon",
  },
  {
    file: "delivery-truck.tsx",
    name: "DeliveryTruckIcon",
  },
  {
    file: "dark-mode.tsx",
    name: "DarkMode",
  },
  {
    file: "cube-solid.tsx",
    name: "CubeSolidIcon",
  },
  {
    file: "crm-icon.tsx",
    name: "CrmDashIcon",
  },
  {
    file: "crm-icon-two.tsx",
    name: "CrmDashTwoIcon",
  },
  {
    file: "cookies.tsx",
    name: "CookiesIcon",
  },
  {
    file: "containers.tsx",
    name: "Containers",
  },
  {
    file: "container-house.tsx",
    name: "ContainerHouseIcon",
  },
  {
    file: "comments.tsx",
    name: "CommentsIcon",
  },
  {
    file: "cold-drink.tsx",
    name: "ColdDrinkIcon",
  },
  {
    file: "cog-solid.tsx",
    name: "CogSolidIcon",
  },
  {
    file: "coffee-cup.tsx",
    name: "CoffeeCupIcon",
  },
  {
    file: "cloud-task.tsx",
    name: "CloudTaskIcon",
  },
  {
    file: "chicken.tsx",
    name: "ChickenIcon",
  },
  {
    file: "check-circle.tsx",
    name: "CheckCircleIcon",
  },
  {
    file: "chat-solid.tsx",
    name: "ChatSolidIcon",
  },
  {
    file: "CCCamera.tsx",
    name: "CCCameraIcon",
  },
  {
    file: "cave.tsx",
    name: "CaveIcon",
  },
  {
    file: "castle.tsx",
    name: "CastleIcon",
  },
  {
    file: "cargo.tsx",
    name: "Cargo",
  },
  {
    file: "cargo-pallet.tsx",
    name: "CargoPallet",
  },
  {
    file: "cargo-damaged.tsx",
    name: "CargoDamaged",
  },
  {
    file: "car-parking.tsx",
    name: "CarParkingIcon",
  },
  {
    file: "calendar.tsx",
    name: "CalenderIcon",
  },
  {
    file: "calendar-two.tsx",
    name: "CalendarTwoIcon",
  },
  {
    file: "cabin.tsx",
    name: "CabinIcon",
  },
  {
    file: "business.tsx",
    name: "BusinessIcon",
  },
  {
    file: "burger.tsx",
    name: "BurgerIcon",
  },
  {
    file: "bulb-solid.tsx",
    name: "BulbSolidIcon",
  },
  {
    file: "brush-solid.tsx",
    name: "BrushSolidIcon",
  },
  {
    file: "blender.tsx",
    name: "BlenderIcon",
  },
  {
    file: "beef.tsx",
    name: "BeefIcon",
  },
  {
    file: "bbq-grill.tsx",
    name: "BBQGrillIcon",
  },
  {
    file: "barn.tsx",
    name: "BarnIcon",
  },
  {
    file: "bag.tsx",
    name: "BagIcon",
  },
  {
    file: "badge-not-allowed.tsx",
    name: "BadgeNotAllowedIcon",
  },
  {
    file: "arrow-side-up-down.tsx",
    name: "ArrowSideUpDownIcon",
  },
  {
    file: "arrow-shape-up.tsx",
    name: "ArrowShapeUpIcon",
  },
  {
    file: "arrow-both-direction.tsx",
    name: "ArrowBothDirectionIcon",
  },
  {
    file: "apple-pay.tsx",
    name: "ApplePayIcon",
  },
  {
    file: "apartment.tsx",
    name: "ApartmentIcon",
  },
  {
    file: "analytics-circular.tsx",
    name: "AnalyticsCircularIcon",
  },
  {
    file: "ali-express.tsx",
    name: "AliExpressIcon",
  },
  {
    file: "airtable.tsx",
    name: "AirtableIcon",
  },
  {
    file: "air-conditioner.tsx",
    name: "AirConditionerIcon",
  },
  {
    file: "affiliate.tsx",
    name: "AffiliateIcon",
  },
  {
    file: "affiliate-colored.tsx",
    name: "AffiliateColoredIcon",
  },
  {
    file: "layout-icons/lithium-icon.tsx",
    name: "LithiumIcon",
  },
  {
    file: "layout-icons/hydrogen-icon.tsx",
    name: "HydrogenIcon",
  },
  {
    file: "layout-icons/helium-icon.tsx",
    name: "HeliumIcon",
  },
  {
    file: "layout-icons/carbon-icon.tsx",
    name: "CarbonIcon",
  },
  {
    file: "layout-icons/boron-icon.tsx",
    name: "BoronIcon",
  },
  {
    file: "layout-icons/beryllium-icon.tsx",
    name: "BerylliumIcon",
  },
  {
    file: "language/USFlag.tsx",
    name: "USFlagIcon",
  },
  {
    file: "language/SAFlag.tsx",
    name: "SAFlagIcon",
  },
  {
    file: "language/ESFlag.tsx",
    name: "ESFlagIcon",
  },
  {
    file: "language/DEFlag.tsx",
    name: "DEFlagIcon",
  },
  {
    file: "language/CNFlag.tsx",
    name: "CNFlagIcon",
  },
];
